import Content from "uxp-documentation/src/pages/uxp-api/reference-html/Hierarchy/h4";
import * as React from 'react';
export default {
  Content,
  React
};